import { Action } from '@ngrx/store';
import { ActionOptionsArgs, SynchronisableAction } from '../../../core/store/actions/base-actions';
import { File } from './file.model';

export const ENTITY = 'file';
export const REMOVE = '[File] Remove';
export const SUBMIT = '[File] Submit';
export const FILE_PREVIEW = '[File] Preview';
export const FILE_PREVIEW_MOBILE = '[File] Preview Mobile';
export const FILE_PREVIEW_MOBILE_LOCAL = '[File] Preview Mobile Local';
export const FILE_PREVIEW_MOBILE_REMOTE = '[File] Preview Mobile Remote';
export const FILE_PREVIEW_DESKTOP = '[File] Preview Desktop';
export const FILE_SHARE = '[File] Share';
export const FILE_SHARE_LOCAL = '[File] Share Local';
export const FILE_SHARE_REMOTE = '[File] Share Remote';
export const FILE_DOWNLOAD = '[File] Download';
export const FILE_DOWNLOAD_DESKTOP = '[File] Download Desktop';
export const FILE_DOWNLOAD_DESKTOP_REMOTE = '[File] Download Desktop Remote';
export const FILE_DOWNLOAD_DESKTOP_LOCAL = '[File] Download Desktop Local';
export const FILE_DOWNLOAD_MOBILE = '[File] Download Mobile';
export const FILE_DOWNLOAD_MOBILE_REMOTE = '[File] Download Mobile Remote';
export const FILE_DOWNLOAD_MOBILE_LOCAL = '[File] Download Mobile Local';
export const REHYDRATE = '[File] Rehydrate';
export const UPDATE_FROM_API = '[File] Update from API';

export class SubmitAction extends SynchronisableAction {
    readonly entity = ENTITY;
    readonly type = SUBMIT;

    constructor(public payload: File, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export class RemoveAction extends SynchronisableAction {
    readonly entity = ENTITY;
    readonly type = REMOVE;

    constructor(public payload: File, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export class ViewFileAction implements Action {
    readonly type = FILE_PREVIEW;

    constructor(public payload: {file: File}) {
    }
}

export class FilePreviewMobileAction implements Action {
    readonly type = FILE_PREVIEW_MOBILE;

    constructor(public payload: {file: File}) {
    }
}

export class FilePreviewMobileLocalAction implements Action {
    readonly type = FILE_PREVIEW_MOBILE_LOCAL;

    constructor(public payload: {file: File}) {
    }
}

export class FilePreviewMobileRemoteAction implements Action {
    readonly type = FILE_PREVIEW_MOBILE_REMOTE;

    constructor(public payload: {file: File}) {
    }
}

export class FilePreviewDesktopAction implements Action {
    readonly type = FILE_PREVIEW_DESKTOP;

    constructor(public payload: {file: File}) {
    }
}

export class FileShareAction implements Action {
    readonly type = FILE_SHARE;

    constructor(public payload: {file: File}) {
    }
}

export class FileShareLocalAction implements Action {
    readonly type = FILE_SHARE_LOCAL;
    constructor(public payload: {path: string}) {
    }
}

export class FileShareRemoteAction implements Action {
    readonly type = FILE_SHARE_LOCAL;
    constructor(public payload: {file: File}) {
    }
}

export class DownloadFileAction implements Action {
    readonly type = FILE_DOWNLOAD;

    constructor(public payload: {file: File}) {
    }
}
export class FileDownloadDesktopAction implements Action {
    readonly type = FILE_DOWNLOAD_DESKTOP;

    constructor(public payload: {file: File}) {
    }
}

export class FileDownloadDesktopLocalAction implements Action {
    readonly type = FILE_DOWNLOAD_DESKTOP_LOCAL;

    constructor(public payload: {file: File}) {
    }
}

export class FileDownloadDesktopRemoteAction implements Action {
    readonly type = FILE_DOWNLOAD_DESKTOP_REMOTE;

    constructor(public payload: {file: File}) {
    }
}
export class FileDownloadMobileAction implements Action {
    readonly type = FILE_DOWNLOAD_MOBILE;

    constructor(public payload: {file: File}) {
    }
}
export class FileDownloadMobileLocalAction implements Action {
    readonly type = FILE_DOWNLOAD_MOBILE_LOCAL;

    constructor(public payload: {file: File}) {
    }
}
export class FileDownloadMobileRemoteAction implements Action {
    readonly type = FILE_DOWNLOAD_MOBILE_REMOTE;

    constructor(public payload: {file: File}) {
    }
}

export class RehydrateAction implements Action {
    readonly entity = ENTITY;
    readonly type = REHYDRATE;

    constructor(public payload: Array<File>) {
    }
}

export class UpdateFromApi implements Action {
    readonly type = UPDATE_FROM_API;

    constructor(public payload: {files: Array<File>}) {

    }
}

export type Actions
    = SubmitAction
    | RemoveAction
    | ViewFileAction
    | FilePreviewMobileAction
    | FilePreviewDesktopAction
    | FileShareAction
    | DownloadFileAction
    | FileDownloadDesktopAction
    | FileDownloadDesktopLocalAction
    | FileDownloadDesktopRemoteAction
    | FileDownloadMobileAction
    | FileDownloadMobileLocalAction
    | FileDownloadMobileRemoteAction
    | RehydrateAction
    | UpdateFromApi
    ;



// WEBPACK FOOTER //
// ./src/vas/business-objects/file/file.actions.ts